import { buildApiUrl } from '@/utils/apiBase.js';

const AUTH_PATH = 'api/auth.php';

/**
 * @returns {Promise<boolean>}
 */
export async function fetchAuthStatus() {
  const r = await fetch(buildApiUrl(AUTH_PATH), { credentials: 'include' });
  const data = await r.json().catch(() => ({}));
  return Boolean(data.authenticated);
}

/**
 * @returns {Promise<boolean>}
 */
export async function loginWithCredentials(username, password) {
  const r = await fetch(buildApiUrl(AUTH_PATH), {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) return false;
  return Boolean(data.ok && data.authenticated);
}

export async function logoutSession() {
  await fetch(buildApiUrl(AUTH_PATH), {
    method: 'DELETE',
    credentials: 'include',
  });
}
